'use strict';

angular.module('dekky.forms.themes.bootstrap', []);